<template>
  <div class="sub-menu-header">
    <span>{{ header }}</span>
  </div>
</template>
<script>
export default {
	name: 'menu-header',
	props: {
		header: {
			type: String,
			required: true
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/app/user/partials/navbar/web/mainMenu/MenuHeader.vue